import {ReactNode} from 'react';

import {Grid} from '@mui/material';

interface Props {
  imageUrl: string;
  children?: ReactNode;
}

export const Banner = ({imageUrl, children}: Props) => {
  return (
    <Grid
      sx={{
        background: `url(${imageUrl})`,
        backgroundSize: 'cover',
        objectFit: 'cover',
        borderRadius: '16px',
      }}
      width='100%'
      minHeight='350px'
    >
      {children}
    </Grid>
  );
};
